export default __webpack_public_path__ + "static/media/niftsy.5a276b87.svg";